export const REDUCER_NAME = 'list'



// WEBPACK FOOTER //
// ./src/modules/anamnesis/state/list/const.js